module.exports = __webpack_public_path__ + "static/media/barclays.a89e5ce0.png";